import { Component, OnInit, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppValidationsHelper } from '../../../../../admin/src/app/app-validations.helper';
import { RoutingStateService } from '../../services/routing-state.service';
import { UserService } from '../../../../../admin/src/app/services/user.service';
import { AuthService } from '../../../../../admin/src/app/services/auth.service';
import { MatomoTracker } from 'ngx-matomo';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  form: FormGroup;

  sub: Subscription;

  completed: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private routingState: RoutingStateService,
    private authSvc: AuthService,
    private userSvc: UserService,
    private matomoTracker: MatomoTracker
  ) { }

  ngOnInit() {
    this.matomoTracker.trackPageView('Register');

    this.form = this.fb.group({
      email: [null, Validators.compose([Validators.required, Validators.email])],
      password: [null],
      confirmPassword: [null],
      firstName: [null, Validators.required],
      lastName: [null, Validators.required]
    }, {
      validator: [AppValidationsHelper.PasswordValidator]
    });
  }

  register() {
    this.form.markAsDirty();
    this.form.markAsTouched();

    if (this.form.valid) {
      let user = Object.assign({}, this.form.value);
      delete user.confirmPassword;

      this.userSvc.add(user).subscribe(data => {
        let credentials = {
          email: user.email,
          password: user.password
        };
        this.authSvc.access(credentials).subscribe(() => {
          this.userSvc.getCurrentUser().subscribe(() => {
            this.completed = true;
          });
        });
      }, error => {
        if (error.code === 15) {
          this.form.get('email').setErrors({ duplicate: true });
        }
      });
    } else {
      AppValidationsHelper.validateFormFields(this.form);
    }

    return false;
  }

  goBack() {
    let previousUrl = this.routingState.getPreviousUrl();
    if (previousUrl === '/register') {
      previousUrl = '/';
    }
    this.router.navigate([previousUrl]);
  }
}
